import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/navigare-companies', data)
    .then(response => {
      return response.data
    })
}
function update(data, id) {
  return axios.patch(`/navigare-companies/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/navigare-companies', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  destroy(id) {
    return axios.delete(`/navigare-companies/${id}`)
  }
}
